'use strict';

var _ = require('lodash');
var ConfigurationMarketClassFareController = function ConfigurationMarketClassFareController($scope, $rootScope, dataRetrieverService, configurationMarketClassFareService) {
  var gridId = 'configuration-market-class-fare-grid';
  $scope.isImportValidationError = false;
  $scope.errorGridState = {
    show: false,
    data: {}
  };
  $scope.VIEW = {
    SURCHARGE: 'surcharges',
    FARE: 'marketFares'
  };
  $scope.views = [{
    label: 'Fares',
    value: $scope.VIEW.FARE,
    screenKey: 'SYSTEM_CONFIGURATION_MARKET_CLASS_FARE_MARKET'
  }, {
    label: 'Surcharges',
    value: $scope.VIEW.SURCHARGE,
    screenKey: 'SYSTEM_CONFIGURATION_FARES_SURCHARGE_UPLOAD_FLIGHT'
  }];
  $scope.selectedView = $scope.VIEW.FARE;
  function save(rows) {
    return configurationMarketClassFareService.saveConfigurationMarketClassFare(rows);
  }
  $scope.saveChanges = function (event, rows) {
    save(rows).then(function () {
      $scope.$broadcast('configuration-market-class-fare:saveSuccess');
      $scope.$broadcast('grid:dataChanged');
    });
  };
  $scope.isErrorGridVisible = function () {
    return $scope.errorGridState.show;
  };
  $scope.isMarketClassFareGridVisible = function () {
    return !$scope.errorGridState.show;
  };
  $scope.saveRemovedRows = function (event, selectedRows) {
    configurationMarketClassFareService.removeMarketClassFares(selectedRows).then(function () {
      $scope.$broadcast('configuration-market-class-fare:saveSuccess');
      $scope.$broadcast('grid:dataChanged');
    });
  };
  $scope.exportToCSV = function (event, loadedData) {
    configurationMarketClassFareService.exportMarketClassFares(gridId, loadedData);
  };
  $scope.updateSearchPanel = function () {
    $rootScope.$broadcast('market-class-fare:view-changed', getCurrentViewKey());
  };
  function getCurrentViewKey() {
    return _.find($scope.views, function (view) {
      return view.value === $scope.selectedView;
    }).screenKey;
  }
};
ConfigurationMarketClassFareController.$inject = ['$scope', '$rootScope', 'DataRetrieverService', 'ConfigurationMarketClassFareService'];
module.exports = ConfigurationMarketClassFareController;